import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.lidodelivery',
  appName: 'Lido Delivery',
  webDir: '../Delivery.Api/wwwroot',
  server: {
    androidScheme: 'http',
  },
  plugins: {
    SystemBars: { insetsHandling: 'css' },
    StatusBar: { overlaysWebView: true, backgroundColor: '#00000000' },
  }
};

export default config;
